app.service('productNav', function (cookie, _, html, productCardConfig, broker, store, callback) {
	let $self, $items, $productTabList;
	let scrollSpyPositions = {};
	let stickyPosition = {
		start: 0,
		end: 0
	};
	let topHeight = 0;
	let config;
	let savedTabName = '';
	let activeTabName = '';

	function init() {

		config = productCardConfig.getData();

		if (!config.navItems.length) return;

		setElements();
		render();

		if (!cookie.isEmpty('sticky-off')) return;

		setScrollSpy();
		setEvents();
	}

	function setElements() {
		$self = $('.js-product-nav');
		$items = $self.find('.nav-items');
		$productTabList = $('#product-tab-list');
	}

	function setEvents() {
		$('#top').on('animationend', () => {
			topHeight = $('#top').height();
			$self.css({top: topHeight});
			setScrollSpy();
			setStickyPosition();
			updateNav();
		});

		broker.on('PRODUCT_OPINION_TAB_QUANTITY_CHANGE', function (e, data){
			opinionTabQuantityChange(data);
		});

		$self.on('click', '.js-scroll-to-top', scrollToTop)
			.on('click', '.nav-item', handleNavItemClick);

		const refreshSticky = _.debounce(function (scrollY) {
			setStickyPosition();
			updateNav(scrollY);
		}, 200);

		$(window).on('resize', refreshSticky);

		_.onScroll(scrollY => {
			setScrollSpy();
			setStickyPosition();
			updateNav(scrollY);
		});

		store.onChange(() => {
			render();
		});
	}

	function handleNavItemClick(e) {
		e.preventDefault();
		$.scrollTo(`[data-section-id=${$(this).attr('href').slice(1)}]`);
		UA.pageInteraction('Sticky', $(this).attr('href').slice(1));
	}

	function setStickyPosition() {
		stickyPosition.start = $productTabList.position().top - $self.height() - topHeight;
		stickyPosition.end = $productTabList.position().top + $productTabList.height() - topHeight - $self.height();
	}

	function setScrollSpy() {
		scrollSpyPositions = {};
		$productTabList.children()
			.filter('.product-tab-section:visible')
			.each(function (index) {
				scrollSpyPositions[index] = $(this).offset().top - $self.height();
			});
	}

	function updateNav(scrollPosition = $(window).scrollTop()) {
		updateStickyPosition(scrollPosition);
		updateActiveItem(scrollPosition);
	}

	function updateStickyPosition(scrollPosition) {

		const beforeSticky = scrollPosition <= stickyPosition.start;
		const isSticky = scrollPosition > stickyPosition.start && scrollPosition <= stickyPosition.end;
		const afterSticky = scrollPosition > stickyPosition.end;

		if (beforeSticky) {
			html.remove('product-nav-sticky');
			html.remove('product-nav-sticky-end');
			return;
		}

		if (isSticky) {
			html.add('product-nav-sticky');
			html.remove('product-nav-sticky-end');
			return;
		}

		if (afterSticky) {
			html.add('product-nav-sticky');
			html.add('product-nav-sticky-end')
		}
	}

	function updateActiveItem(scrollPosition) {
		let $children = $items.children().filter(':visible');

		const topOuterHeight = topHeight + 8;

		if (scrollSpyPositions[0] - topOuterHeight > scrollPosition) {
			$children.removeClass('is-active');
			return;
		}

		for (let index in scrollSpyPositions) {

			if (scrollSpyPositions[index] - topOuterHeight <= scrollPosition) {
				$children.removeClass('is-active').eq(index).addClass('is-active');
				activeTabName = $children.eq(index).attr('href').slice(1);
			}
		}

		if(savedTabName !== activeTabName) {
			savedTabName = activeTabName;
			callback.run('ACTIVE_TAB_NAME', savedTabName);
		}
	}

	function opinionTabQuantityChange(quantity){
		$('#product-nav .nav-item[href="#opinie"]').text(`Opinie (${quantity})`);
	}

	function render() {
		$items.empty();

		const skipItemsForOutlet = item => !(store.data.isOutlet && ['zestaw'].indexOf(item.hash) >= 0);
		config.navItems
			.filter(skipItemsForOutlet)
			.map(createLink)
			.forEach($link => {
				$items.append($link);
			});
		$items.append(createScrollToTopBtn)
	}

	function createLink(item) {
		return $('<a />').text(item.name).attr({
			class: `nav-item menu-category-${item.hash}`,
			href: `#${item.hash}`
		});
	}

	function createScrollToTopBtn() {
		return $('<button />').text('Wróć na górę').attr({
			type: 'button',
			class: `scroll-to-top-btn js-scroll-to-top`,
		});
	}

	function scrollToTop() {
		$.scrollTo(0, 500);
	}

	function isSectionAvailable(sectionName) {
		return config.navItems.find(item => item.hash === sectionName);
	}

	return {
		init,
		dynamicSuiteAvailable: () => isSectionAvailable("zestaw"),
		accessoriesAvailable: () => isSectionAvailable("akcesoria"),
		specificationAvailable: () => isSectionAvailable("specyfikacja"),
		productQuestionAvailable: () => isSectionAvailable("pytania"),
		opinionAvailable: () => isSectionAvailable("opinie"),
		isSectionAvailable
	};
});